import React, { Component } from "react";

import {
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CLabel,
  CSelect,
  CSpinner,
  CSwitch
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import Select from "react-select";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import Uploader from "../../../../components/Uploader/uploader";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import {
  getAbilityName,
  getDisciplineName,
  getDisciplines
} from "../../../../utils/bncc";

class LoCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      loading: false,
      fields: [],
      series: [],
      creating: false,
      segments: [],
      ability: null,
      module: null,
      discipline: "",
      showPrintable: false,
      printable: false,
      // Novos estados para habilidades extras
      extraAbilitiesOptions: [],
      selectedExtraAbilities: [],
      // Estado para armazenar todas as habilidades (para o select de extras)
      allAbilities: []
    };

    this.error = this.error.bind(this);
    this.fieldsMount = this.fieldsMount.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
    this.formRef = React.createRef();
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.match.params;
    this.setState(
      () => ({
        loading: true
      }),
      () => {
        Promise.all([
          axios.get(`${URL.api}content/type/list`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }),
          axios.get(`${URL.api}classification/ability/filterStructure`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }),
          axios.get(`${URL.api}classification/ability/list`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
        ])
          .then(([respType, respSegments, respAbilities]) => {
            const fieldsArray = this.fieldsMount(
              respType.data.data.filter(item => item.lo_create),
              [],
              [],
              []
            );

            // Mapeia todas as habilidades para o select de extras
            const allAbilities = respAbilities.data.data.map(item => ({
              value: item.id,
              label: `${item.code} - ${item.description}`
            }));

            this.setState(
              {
                fields: fieldsArray,
                segments: respSegments.data.data,
                allAbilities,
                extraAbilitiesOptions: allAbilities // reutiliza a lista
              },
              () => {
                if (!id) {
                  this.setState({ loading: false });
                } else {
                  axios
                    .get(`${URL.api}content/los/singleView/${id}`, {
                      headers: {
                        authorization: `Bearer ${this.props.user.token}`
                      }
                    })
                    .then(resp => {
                      if (resp.data.success) {
                        const data = resp.data.data;
                        const los = data.los; // <-- extrai o objeto los

                        let segment = null;
                        if (los.series && los.series.length > 0) {
                          segment = los.series[0].segment_id;
                        } else if (los.segment_id) {
                          segment = los.segment_id;
                        } else if (los.module_segment_id) {
                          segment = los.module_segment_id;
                        }

                        let discipline = null;
                        if (los.discipline_id) {
                          discipline = los.discipline_id;
                        } else if (los.module_discipline_id) {
                          discipline = los.module_discipline_id;
                        }

                        const extraAbilities = Array.isArray(
                          data.extra_abilities
                        )
                          ? data.extra_abilities.map(item => ({
                              value: item.id,
                              label: `${item.code} - ${item.description}`
                            }))
                          : [];

                        this.setState({
                          lo: los, // <-- agora é o objeto com os campos do LO
                          path: los.path,
                          image: los.image,
                          pdf: los.pdf_path,
                          edit: true,
                          loading: false,
                          series: Array.isArray(los.series)
                            ? los.series.map(serie => ({
                                value: serie.id,
                                label: serie.name
                              }))
                            : [],
                          ability: los.ability_id || null,
                          module: los.module_id || null,
                          segment,
                          discipline,
                          selectedExtraAbilities: extraAbilities
                        });
                      }
                    })
                    .catch(error => {
                      this.error("Não foi possível obter as informações");
                      this.setState({ loading: false });
                      this.error("Não foi possível obter as informações");
                      this.setState({ loading: false });
                    });
                }
              }
            );
          })
          .catch(error => {
            this.error("Não foi possível obter as informações");
            this.setState({ loading: false });
          });
      }
    );
  }

  fieldsMount(type, ability, skin, language) {
    let optionsType = [];
    for (let i = 0; i < type.length; i++) {
      if (i < type.length) {
        let obj = {
          value: type[i].id,
          name: type[i].name
        };
        optionsType[i] = obj;
      }
    }

    let optionsSkin = [];
    for (let i = 0; i < skin.length; i++) {
      let obj = {
        value: skin[i].id,
        name: skin[i].name
      };
      optionsSkin[i] = obj;
    }

    let optionsLanguage = [];
    for (let i = 0; i < language.length; i++) {
      let obj = {
        value: language[i].id,
        name: language[i].name
      };
      optionsLanguage[i] = obj;
    }

    let optionsBinary = [
      {
        value: false,
        name: "Não"
      },
      {
        value: true,
        name: "Sim"
      }
    ];

    let optionsStatus = [
      {
        value: "Em produção",
        name: "Em produção"
      },
      {
        value: "Homologado",
        name: "Homologado"
      },
      {
        value: "Liberado",
        name: "Liberado"
      }
    ];

    let defaultType = "";

    if (!this.state.edit) {
      const query = new URLSearchParams(window.location.search);
      defaultType = query.get("type");
    }

    let Fields = [
      {
        name: "name",
        label: "Nome",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required]
      },
      {
        name: "type_id",
        label: "Tipo",
        type: "select",
        required: true,
        icon: "fa fa-text-width",
        options: optionsType,
        value: defaultType,
        validate: [required, alphaNumeric]
      },
      {
        name: "flash",
        label: "Conteúdo Flash",
        type: "select",
        required: true,
        options: optionsBinary,
        icon: "fa fa-lock",
        value: false,
        validate: [required]
      },
      {
        name: "resume",
        label: "Resumo (Opcional)",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: []
      },
      {
        name: "objective",
        label: "Objetivo (Opcional)",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: []
      },
      {
        name: "year",
        label: "Ano",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "status",
        label: "Status",
        type: "select",
        required: true,
        icon: "fa fa-text-width",
        options: optionsStatus,
        value: "",
        validate: [required, alphaNumeric]
      }
    ];

    return Fields;
  }

  enviar(value) {
    this.setState({ creating: true });

    let error = false;

    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      type_id: value.type_id,
      path: this.state.path,
      ability_id: this.state.ability,
      module_id: this.state.module,
      released: true,
      private: false,
      flash: value.flash || false,
      user_id: this.props.user.user.id,
      skin_id: 1,
      tag: null,
      resume: value.resume,
      objective: value.objective,
      image: this.state.image,
      pdf_path: this.state.pdf,
      author: "Educandus",
      language_id: 1,
      status: value.status,
      year: value.year,
      source_id: 1,
      difficulty_level_id: 1,
      series: this.state.series.map(serie => serie.value),
      printable: this.state.showPrintable && this.state.printable,
      extra_abilities: this.state.selectedExtraAbilities.map(item => item.value)
    };

    if (
      !(obj.flash.toString() === "true" || obj.flash.toString() === "false")
    ) {
      this.error("Preencha o campo 'Conteúdo Flash'");
      error = true;
    }

    if (!error) {
      if (this.state.path === undefined) {
        toastr.error(
          "Falha",
          "Favor fazer o envio do arquivo no início da página."
        );
        this.setState({ creating: false });
      } else if (this.state.image === undefined) {
        toastr.error(
          "Falha",
          "Favor fazer o envio da imagem no início da página."
        );
        this.setState({ creating: false });
      } else {
        axios
          .post(`${URL.api}content/los/insert`, obj, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(
            resp => {
              if (resp.data.success) {
                this.props.history.push(`/lo/${value.type_id}/list`);
                this.setState({ creating: false });
              } else {
                this.error("Não foi possível inserir o LO");
                this.setState({ creating: false });
              }
            },
            error => {
              this.error("Não foi possível inserir o LO");
              this.setState({ creating: false });
            }
          );
      }
    } else {
      this.setState({ creating: false });
    }
  }

  atualizar(value) {
    this.setState({ creating: true });

    let error = false;

    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      type_id: value.type_id,
      path: this.state.path,
      ability_id: this.state.ability,
      module_id: this.state.module,
      released: true,
      private: false,
      flash: value.flash,
      user_id: this.props.user.user.id,
      skin_id: 1,
      tag: null,
      resume: value.resume,
      objective: value.objective,
      image: this.state.image,
      pdf_path: this.state.pdf,
      author: "Educandus",
      language_id: 1,
      status: value.status,
      year: value.year,
      source_id: 1,
      difficulty_level_id: 1,
      series: this.state.series.map(serie => serie.value),
      printable: this.state.showPrintable && this.state.printable,
      extra_abilities: this.state.selectedExtraAbilities.map(item => item.value)
    };

    if (
      !(obj.flash.toString() === "true" || obj.flash.toString() === "false")
    ) {
      this.error("Preencha o campo 'Conteúdo Flash'");
      error = true;
    }

    if (!error) {
      axios
        .post(`${URL.api}content/los/update/${value.id}`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          if (resp.data.success) {
            this.props.history.push(`/lo/${value.type_id}/list`);
            this.setState({ creating: false });
          } else {
            this.error("Não foi possível editar o LO");
            this.setState({ creating: false });
          }
        });
    } else {
      this.setState({ creating: false });
    }
  }

  done(uploads) {
    this.setState(() => ({
      image: URL.img + uploads[0]
    }));
  }

  done2(uploads2) {
    this.setState(() => ({
      path: URL.img + uploads2[0]
    }));
  }

  changeSegment(e) {
    const segment = parseInt(e.target.value);

    this.setState({
      segment,
      series: [],
      ability: null,
      module: null,
      discipline: ""
    });
  }

  changeDiscipline(e) {
    const discipline = parseInt(e.target.value);
    this.setState({ discipline, series: [], ability: null, module: null });
  }

  render() {
    let defaultType = 1;

    if (!this.state.edit) {
      const query = new URLSearchParams(window.location.search);
      defaultType = query.get("type");
    }

    // Filtra segmentos com disciplinas que tenham objetivos com abilities ou modules
    const segments =
      this.state.segments.filter(
        segment =>
          segment.disciplines &&
          segment.disciplines.filter(
            discipline =>
              discipline.objectives &&
              discipline.objectives.filter(
                objective =>
                  objective.abilities.length > 0 || objective.modules.length > 0
              ).length > 0
          ).length > 0
      ) || [];

    const disciplines =
      (
        segments.find(segment => segment.id === this.state.segment)
          ?.disciplines || []
      ).filter(
        discipline =>
          discipline.objectives &&
          discipline.objectives.filter(
            objective =>
              objective.abilities.length > 0 || objective.modules.length > 0
          ).length > 0
      ) || [];

    const objectives =
      (
        disciplines.find(discipline => discipline.id === this.state.discipline)
          ?.objectives || []
      ).filter(
        objective =>
          objective.abilities.length > 0 || objective.modules.length > 0
      ) || [];

    const abilities = objectives
      .map(objective => ({
        label: objective.description,
        id: objective.id,
        options: objective.abilities.map(ability => ({
          label: `(${ability.code}) ${ability.description}`,
          value: ability.id,
          objective: objective.id,
          series: ability.series,
          thematic_unit_name: objective.thematic_unit_name,
          objective_name: objective.description
        }))
      }))
      .filter(objective => objective.options.length > 0);

    const modules = objectives
      .map(objective => ({
        label: objective.description,
        id: objective.id,
        options: objective.modules.map(module => ({
          label: module.description,
          value: module.id,
          objective: objective.id,
          series: module.series,
          thematic_unit_name: objective.thematic_unit_name,
          objective_name: objective.description
        }))
      }))
      .filter(objective => objective.options.length > 0);

    const ability =
      abilities
        .reduce((acc, val) => [...acc, ...val.options], [])
        .find(ability => ability.value === this.state.ability) || null;

    const module =
      modules
        .reduce((acc, val) => [...acc, ...val.options], [])
        .find(module => module.value === this.state.module) || null;

    const seriesAbilities =
      ability?.series
        .filter(serie => serie.segment_id === this.state.segment)
        .map(item => ({
          label: item.name,
          value: item.id,
          order: item.order
        })) || [];

    const seriesModules =
      module?.series
        .filter(serie => serie.segment_id === this.state.segment)
        .map(item => ({
          label: item.name,
          value: item.id,
          order: item.order
        })) || [];

    const series = [...seriesAbilities, ...seriesModules]
      .filter((v, i, a) => a.findIndex(item => item.value === v.value) === i)
      .sort((a, b) => a.order - b.order);

    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[
            {
              path: "/lo/:content/list",
              to: `/lo/${this.state.lo?.type_id || defaultType}/list`
            }
          ]}
        />
        {this.state.loading ? (
          <Loading />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar LO" : "Criar LO"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit ? "Edite o LO" : "Crie um novo LO"}
                </div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.formRef.current.submit()}
                disabled={this.state.creating}
              >
                <>
                  <span style={this.state.creating ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.creating && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody>
              <CLabel className="d-flex align-items-center mb-2">
                Arquivo do LO
                {this.state.path && (
                  <CBadge
                    color="primary"
                    className="ml-2"
                    href={this.state.path}
                    target="_blank"
                  >
                    Abrir
                  </CBadge>
                )}
              </CLabel>
              <Uploader
                type="lo"
                maxFiles={1}
                allowMultiple
                labelIdle='Arraste e solte seu arquivo ou <span class="filepond--label-action">procure</span>'
                done={uploads => this.setState({ path: URL.img + uploads[0] })}
              />
              <CLabel className="d-flex align-items-center mb-2">
                Imagem do LO
                {this.state.image && (
                  <CBadge
                    color="primary"
                    className="ml-2"
                    href={this.state.image}
                    target="_blank"
                  >
                    Ver
                  </CBadge>
                )}
              </CLabel>
              <Uploader
                type="lo"
                maxFiles={1}
                acceptedFileTypes={["image/*"]}
                allowMultiple
                labelIdle='Arraste e solte sua imagem ou <span class="filepond--label-action">procure</span>'
                done={uploads => this.setState({ image: URL.img + uploads[0] })}
              />
              <CLabel className="d-flex align-items-center mb-2">
                PDF do LO
                {this.state.pdf && (
                  <CBadge
                    color="primary"
                    className="ml-2"
                    href={this.state.pdf}
                    target="_blank"
                  >
                    Ver
                  </CBadge>
                )}
              </CLabel>
              <Uploader
                type="lo"
                maxFiles={1}
                labelIdle='Arraste e solte seu PDF ou <span class="filepond--label-action">procure</span>'
                done={uploads => this.setState({ pdf: URL.img + uploads[0] })}
              />
              <Form
                key={this.state.lo?.id || "new"}
                avatar
                fields={this.state.fields}
                back={false}
                history={this.props.history}
                onSubmit={this.state.edit ? this.atualizar : this.enviar}
                initialValues={this.state.lo}
                edit={this.state.edit}
                ref={this.formRef}
                onChange={e =>
                  this.setState({ showPrintable: e.type_id === "9" })
                }
              />
              {this.state.showPrintable && (
                <CFormGroup>
                  <CLabel>Material imprimível</CLabel>
                  <CInputGroup className="flex-nowrap">
                    <CSwitch
                      color="primary"
                      checked={this.state.printable}
                      onChange={e =>
                        this.setState({ printable: e.target.checked })
                      }
                      shape="pill"
                    />
                  </CInputGroup>
                </CFormGroup>
              )}
              <CFormGroup>
                <CLabel>Segmento</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    placeholder="Segmento"
                    value={this.state.segment}
                    onChange={e => this.changeSegment(e)}
                  >
                    <option>Segmento</option>
                    {segments.map(segment => (
                      <option key={segment.id} value={segment.id}>
                        {segment.name}
                      </option>
                    ))}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>{getDisciplineName(this.state.segment)}</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    placeholder={getDisciplineName(this.state.segment)}
                    value={this.state.discipline}
                    onChange={e => this.changeDiscipline(e)}
                  >
                    <option>{getDisciplineName(this.state.segment)}</option>
                    {getDisciplines(this.state.segment, disciplines).map(
                      discipline => (
                        <option key={discipline.id} value={discipline.id}>
                          {discipline.name}
                        </option>
                      )
                    )}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>{getAbilityName(this.state.segment)}</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    placeholder={getAbilityName(this.state.segment)}
                    name={getAbilityName(this.state.segment)}
                    options={(() => {
                      // Clona as opções originais
                      const opts = abilities.map(group => ({
                        ...group,
                        options: [...group.options]
                      }));
                      // Se a habilidade atual não estiver presente, adiciona
                      if (this.state.ability) {
                        const exists = opts.some(group =>
                          group.options.some(
                            opt => opt.value === this.state.ability
                          )
                        );
                        if (!exists) {
                          const abilityData = this.state.allAbilities?.find(
                            a => a.value === this.state.ability
                          );
                          if (abilityData) {
                            if (opts.length > 0) {
                              opts[0].options.push(abilityData);
                            } else {
                              opts.push({
                                label: "Outros",
                                options: [abilityData]
                              });
                            }
                          }
                        }
                      }
                      return opts;
                    })()}
                    value={(() => {
                      // Busca o valor NA MESMA LISTA DE OPÇÕES (modificada)
                      const allOpts = abilities
                        .map(group => group.options)
                        .flat();
                      // Adiciona a habilidade atual se não estiver na lista
                      let fullOpts = [...allOpts];
                      if (this.state.ability) {
                        const exists = fullOpts.some(
                          opt => opt.value === this.state.ability
                        );
                        if (!exists) {
                          const abilityData = this.state.allAbilities?.find(
                            a => a.value === this.state.ability
                          );
                          if (abilityData) fullOpts.push(abilityData);
                        }
                      }
                      return (
                        fullOpts.find(
                          opt => opt.value === this.state.ability
                        ) || null
                      );
                    })()}
                    noOptionsMessage={() => "Nada encontrado"}
                    className="basic-multi-select flex-1"
                    classNamePrefix="select"
                    onChange={e =>
                      this.setState({ ability: e.value, series: [] })
                    }
                  />
                </CInputGroup>
              </CFormGroup>
              {ability && (
                <div
                  className="pl-3"
                  style={{ borderLeft: "4px solid var(--light)" }}
                >
                  <CFormGroup>
                    <CLabel>Objetivo</CLabel>
                    <div className="text-muted">{ability.objective_name}</div>
                  </CFormGroup>
                  <CFormGroup>
                    <CLabel>Unidade Temática</CLabel>
                    <div className="text-muted">
                      {ability.thematic_unit_name}
                    </div>
                  </CFormGroup>
                </div>
              )}
              <CFormGroup>
                <CLabel>Módulo (Opcional)</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    placeholder="Módulo"
                    name="Módulo"
                    options={(() => {
                      const opts = modules.map(group => ({
                        ...group,
                        options: [...group.options]
                      }));
                      if (this.state.module) {
                        const exists = opts.some(group =>
                          group.options.some(
                            opt => opt.value === this.state.module
                          )
                        );
                        if (!exists) {
                          const moduleData = this.state.allAbilities?.find(
                            a => a.value === this.state.module
                          );
                          if (moduleData) {
                            if (opts.length > 0) {
                              opts[0].options.push(moduleData);
                            } else {
                              opts.push({
                                label: "Outros",
                                options: [moduleData]
                              });
                            }
                          }
                        }
                      }
                      return opts;
                    })()}
                    value={(() => {
                      const allOpts = modules
                        .map(group => group.options)
                        .flat();
                      let fullOpts = [...allOpts];
                      if (this.state.module) {
                        const exists = fullOpts.some(
                          opt => opt.value === this.state.module
                        );
                        if (!exists) {
                          const moduleData = this.state.allAbilities?.find(
                            a => a.value === this.state.module
                          );

                          if (moduleData) fullOpts.push(moduleData);
                        }
                      }
                      return (
                        fullOpts.find(opt => opt.value === this.state.module) ||
                        null
                      );
                    })()}
                    noOptionsMessage={() => "Nada encontrado"}
                    className="basic-multi-select flex-1"
                    classNamePrefix="select"
                    onChange={e =>
                      this.setState({ module: e.value, series: [] })
                    }
                  />
                </CInputGroup>
              </CFormGroup>
              {module && (
                <div
                  className="pl-3"
                  style={{ borderLeft: "4px solid var(--light)" }}
                >
                  <CFormGroup>
                    <CLabel>Objetivo</CLabel>
                    <div className="text-muted">{module.objective_name}</div>
                  </CFormGroup>
                  <CFormGroup>
                    <CLabel>Unidade Temática</CLabel>
                    <div className="text-muted">
                      {module.thematic_unit_name}
                    </div>
                  </CFormGroup>
                </div>
              )}
              <CFormGroup>
                <CLabel>Séries</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    isMulti
                    placeholder="Séries"
                    name="Séries"
                    noOptionsMessage={() => "Nada encontrado"}
                    options={series}
                    value={this.state.series}
                    className="basic-multi-select flex-1"
                    classNamePrefix="select"
                    onChange={e => this.setState({ series: e })}
                  />
                </CInputGroup>
              </CFormGroup>

              {/* NOVO: Habilidades extras */}
              <CFormGroup>
                <CLabel>Habilidades adicionais</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-plus-circle"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    isMulti
                    placeholder="Selecione habilidades adicionais"
                    options={this.state.extraAbilitiesOptions}
                    value={this.state.selectedExtraAbilities}
                    className="basic-multi-select flex-1"
                    classNamePrefix="select"
                    onChange={e =>
                      this.setState({ selectedExtraAbilities: e || [] })
                    }
                  />
                </CInputGroup>
              </CFormGroup>
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LoCreate);
